export module StringUtil {
  export function isBlank(input: string) {
    return !input || !input.trim();
  }

  export function joinStringArrByComma(arr: string[]) {
    return arr.join(", ");
  }
}
